// Load Libraries
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

// Define jQuery Selectors
var FORM_ERROR              = '.form__error';               // Selector form error message
var FORM_FIELD              = '.form__field';               // Field container
var FORM_CONTROL            = '.form__control';             // Selector for any type of form control

// Define Classes
var INPUT_VALID             = 'input--valid';               // Input is valid
var INPUT_INVALID           = 'input--invalid';             // Input is invalid
var FORM_VALID              = 'form--valid';                // Form is fully validated
var FORM_INVALID            = 'form--invalid';              // Form has at least 1 invalid field
var FORM_FIELD_ICONS        = '.form__field-icons__icon';   // Form field icon
var FORM_FIELD_CONTAINER    = '.form__field-wrapper';       // Container holding form field

// Submit Button
var FORM_SUBMIT             = '.form__submit';               // Form Submit Button

// Form Response
var FORM_RESPONSE_CONTAINER = 'form__response';             // Container holding the response
var FORM_RESPONSE_MESSAGE   = 'form__responseMessage';      // Container holding the response message
var FORM_RESPONSE_SUCCESS   = 'form__response--success';    // Class if the response is successful
var FORM_RESPONSE_ERROR     = 'form__response--error';      // Class if the response is an error

// Credit Card validation
var FIELD_CREDIT_CARD       = 'input__field--creditCard';            // Class for Credit Card inputs
var ICON_CREDIT_CARD        = '.form__fieldIcons__icon--creditCard'; // Selector for Credit Card icons
var ICON_ACTIVE             = 'form__fieldIcons__icon--active';      // Icon active class
var ICON_INACTIVE           = 'form__fieldIcons__icon--inactive';    // Icon inactive class

var MAILCHECK_SUGGESTED     = '.suggested__message';



var ValidationHelpers = function () {};


/*
 * Regular Form Submit
 */
ValidationHelpers.prototype.doNativeSubmit = function(form) {
    // Call submit via a stub form element because "form.submit()" can get overwritten by
    // fields with the name "submit" (e.g. <input type="hidden" name="submit" value="someAction" />)
    // Source: http://stackoverflow.com/questions/8729319/how-send-a-form-with-javascript-when-input-name-is-submit
    document.createElement('form').submit.call(form);
};


/*
 * Show a response message after submission
 */
ValidationHelpers.prototype.showMessage = function (form, message, success) {

    var $form = $(form);

    // Find or Create the Response Container
    var $responseContainer = $form.find('.'+FORM_RESPONSE_CONTAINER);
    var $suggestedMsg = $form.find(MAILCHECK_SUGGESTED);

    if (!$responseContainer.length) {
        $responseContainer = $('<div />')
                                .addClass(FORM_RESPONSE_CONTAINER)
                                .appendTo($form);
    }

    // Set the Success Status of the container
    if (success) {
        $responseContainer
            .removeClass(FORM_RESPONSE_ERROR)
            .addClass(FORM_RESPONSE_SUCCESS);
    }
    else {
        $responseContainer
            .removeClass(FORM_RESPONSE_SUCCESS)
            .addClass(FORM_RESPONSE_ERROR);
    }

    // Find or Create the Response Message
    var $responseMessage = $form.find('.'+FORM_RESPONSE_MESSAGE);

    if (!$responseMessage.length) {
        $responseMessage = $('<div />')
                                .addClass(FORM_RESPONSE_MESSAGE)
                                .appendTo($responseContainer);
    }

    $suggestedMsg.hide();
    $responseMessage.html(message);

};


/**
 * Set the loading state
 */
ValidationHelpers.prototype.setLoading = function(form, isLoading) {
    $button = $(form).find(FORM_SUBMIT);

    // Start the Spinner
    if (isLoading) {
        $button.addClass('isLoading');
        $button.attr('disabled', 'disabled');
        $(form).bind('submit.disabled', function(e){e.preventDefault();});
    // Stop the Spinner
    } else {
        $button.removeClass('isLoading');
        $button.removeAttr('disabled', 'disabled');
        $(form).unbind('submit.disabled');
    }
};


/*
 * Highlight Credit Card Type validation icon
 * Based on "additional-methods.js" provided by jQuery Validation Plugin v1.14.0
 */
ValidationHelpers.prototype.highlightCreditCardType = function(element) {

    var value = $(element).val();
    value = value.replace(/\D/g, '');

    // Remove active/inactive states
    $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).removeClass(ICON_ACTIVE).removeClass(ICON_INACTIVE);

    // Mark active state of the matching CC type
    if (/^(5[12345])/.test(value)) { // mastercard
        $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).addClass(ICON_INACTIVE);
        $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + FORM_FIELD_ICONS+'--mastercard').removeClass(ICON_INACTIVE).addClass(ICON_ACTIVE);
    }
    if (/^(4)/.test(value)) { // visa
        $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).addClass(ICON_INACTIVE);
        $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + FORM_FIELD_ICONS+'--visa').removeClass(ICON_INACTIVE).addClass(ICON_ACTIVE);
    }
    if (/^(3[47])/.test(value)) { // amex
        $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).addClass(ICON_INACTIVE);
        $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + FORM_FIELD_ICONS+'--amex').removeClass(ICON_INACTIVE).addClass(ICON_ACTIVE);
    }
    // if (/^(3(0[012345]|[68]))/.test(value)) { // dinersclub
    //     $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).addClass(ICON_INACTIVE);
    //     $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + FORM_FIELD_ICONS+'--dinersclub').removeClass(ICON_INACTIVE).addClass(ICON_ACTIVE);
    // }
    // if (/^(2(014|149))/.test(value)) { // enroute
    //     $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).addClass(ICON_INACTIVE);
    //     $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + FORM_FIELD_ICONS+'--enroute').removeClass(ICON_INACTIVE).addClass(ICON_ACTIVE);
    // }
    if (/^(6011)/.test(value)) { // discover
        $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).addClass(ICON_INACTIVE);
        $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + FORM_FIELD_ICONS+'--discover').removeClass(ICON_INACTIVE).addClass(ICON_ACTIVE);
    }
    // if (/^(3)/.test(value)) { // jcb
    //     $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).addClass(ICON_INACTIVE);
    //     $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + FORM_FIELD_ICONS+'--jcb').removeClass(ICON_INACTIVE).addClass(ICON_ACTIVE);
    // }
    // if (/^(2131|1800)/.test(value)) { // jcb
    //     $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD).addClass(ICON_INACTIVE);
    //     $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + FORM_FIELD_ICONS+'--jcb').removeClass(ICON_INACTIVE).addClass(ICON_ACTIVE);
    // }

    // Populate the CC Type field (if one exists)
    var ccTypeActive = $(element).closest(FORM_FIELD_CONTAINER).find(ICON_CREDIT_CARD + '.' + ICON_ACTIVE);
    if (ccTypeActive && ccTypeActive.data('cc-type-id') && ccTypeActive.data('cc-type-value')) {
        $('#'+ccTypeActive.data('cc-type-id')).val(ccTypeActive.data('cc-type-value'));
    }
};


ValidationHelpers.prototype.loadFormMessages = function(form) {

    // Find the elements that have rules attached
    $(form).find(FORM_CONTROL).filter(function() {
        return $(this).data('validation') !== undefined;
    }).each(function() {

        var fieldValidation = $(this).data('validation');
        var fieldRules      = fieldValidation.rules;
        var fieldMessages   = fieldValidation.messages;
        // var fieldId         = $(this).attr('id');
        // var fieldName       = $(this).attr('name');
        // var fieldType       = $(this).attr('type');

        // TODO checkbox validation works with multiple checkbox sets
        // // Use the field ID unless it's a group selection
        // var ruleID          = fieldId ? fieldId : fieldName;
        // if ($.inArray(fieldType, ['checkbox', 'radio']) == 1) {
        //     ruleID          = fieldName;
        // }

        // Check to see if fieldRules or fieldMessages are defined
        // #1: They're not empty (i.e. undefined)
        // #2: They're not arrays (formKit defines empty properties as "empty arrays", which normally evaluate to true)
        var isFieldRulesDefined     = fieldRules && !(fieldRules instanceof Array);
        var isFieldMessagesDefined  = fieldMessages && !(fieldMessages instanceof Array);

        // Build the New Rules object:
        // http://jqueryvalidation.org/rules/
        //
        // For Example:
        // {
        //     required: true,
        //     messages: {
        //       required: 'This is Required'
        //     }
        // }
        var newRules = {};
        if (isFieldRulesDefined) {
            newRules = fieldRules;
        }
        if (isFieldMessagesDefined) {
            newRules.messages = fieldMessages;
        }

        // console.log('fieldValidation:', fieldValidation);
        // console.log('fieldRules:', fieldRules);
        // console.log('fieldMessages:', fieldMessages);
        // console.log('newRules:', newRules);

        // Remove any existing rules
        // TODO: consider if we shouldn't do this (e.g. another script wants to add rules beyond what's attached to the data-validation)
        $(this).rules('remove');

        // Bind Rules directly to the Form Elements
        if (!$.isEmptyObject(newRules)) {
            // Add the rules to the element
            $(this).rules('add', newRules);
        }
    });
};


module.exports = new ValidationHelpers();
